import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { executeReports } from "../../store/reports/actions";

export const useApiPostExecuteReports = (trigger: boolean, reportBody: any) => {
  const dispatch = useDispatch();

  const { loadingExecuteReports, responseExecuteReports, errorExecuteReports } =
    useSelector((state: any) => ({
      loadingExecuteReports: state.Reports.loadingExecuteReports,
      responseExecuteReports: state.Reports.responseExecuteReports?.data,
      errorExecuteReports: state.Reports.errorExecuteReports,
    }));

  useEffect(() => {
    if (trigger) {
      dispatch(executeReports(reportBody));
    }
  }, [trigger, reportBody]);

  return {
    loadingExecuteReports,
    responseExecuteReports,
    errorExecuteReports,
  };
};
